import { apiClient } from './api';
import type {
  AdminPaymentSummary,
  ApartmentSummary,
  PagedResponse,
  PaymentListFilter,
} from '../types/payment';

export const paymentService = {
  /**
   * GET /admin/payments
   * Returns a paginated, filterable list of all payments across all apartments.
   * Requires ROLE_owners.
   */
  async getAdminPayments(
    filter: PaymentListFilter = {},
    page = 0,
    size = 20,
  ): Promise<PagedResponse<AdminPaymentSummary>> {
    const params: Record<string, string | number> = { page, size };

    if (filter.apartmentName) params.apartmentName = filter.apartmentName;
    if (filter.guestFirstName) params.guestFirstName = filter.guestFirstName;
    if (filter.guestLastName)  params.guestLastName  = filter.guestLastName;
    if (filter.guestEmail)     params.guestEmail     = filter.guestEmail;
    if (filter.createdAtFrom)  params.createdAtFrom  = filter.createdAtFrom;
    if (filter.createdAtTo)    params.createdAtTo    = filter.createdAtTo;

    const response = await apiClient.get<PagedResponse<AdminPaymentSummary>>(
      '/admin/payments',
      { params },
    );
    return response.data;
  },

  /**
   * GET /admin/apartments/summary
   * Returns a lightweight list of all apartments (ID + name) for filter controls.
   * Requires ROLE_owners.
   */
  async getApartmentSummaries(): Promise<ApartmentSummary[]> {
    const response = await apiClient.get<ApartmentSummary[]>(
      '/admin/apartments/summary',
    );
    return response.data;
  },
};
